/**
 * Sepete ekle, WhatsApp ve kapida odeme butonlarini ayni kolonda alt alta dizer.
 *
 * Kapida odeme uygulamasi kendi butonunu sepete ekle dugmesinin yanina ekler.
 * WhatsApp ise ayri bir bloktadir. Bu betik ucunu de .product-form__buttons
 * icine, su sirayla alir: sepete ekle, WhatsApp, kapida odeme.
 * Paket ve cerceve modullerinin kendi sepete ekle dugmesi varsa o kullanilir.
 */
(function () {
  const root = document.querySelector('product-info');
  if (!root) return;

  let arranging = false;

  function visible(el) {
    if (!el || el.hidden) return false;
    const style = getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function ensureNote(parent) {
    let note = root.querySelector('.purchase-activate-note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'purchase-activate-note';
      note.textContent = 'Seçimler yapıldıktan sonra aktif olacaktır';
      parent.appendChild(note);
    }
    return note;
  }

  function placeNote(moduleButton, anchor) {
    const waiting =
      moduleButton &&
      visible(moduleButton) &&
      moduleButton.disabled &&
      !/ekleniyor/i.test(moduleButton.textContent);
    const note = root.querySelector('.purchase-activate-note') || (waiting ? ensureNote(anchor.parentElement) : null);
    if (waiting && note) {
      if (note.hidden) note.hidden = false;
      if (note.previousElementSibling !== anchor) anchor.insertAdjacentElement('afterend', note);
      return note;
    }
    if (note && !note.hidden) note.hidden = true;
    return anchor;
  }

  function arrange() {
    if (arranging) return;
    const buttons = root.querySelector('.product-form__buttons');
    const submit = buttons && buttons.querySelector('.product-form__submit');
    const moduleButton = root.querySelector('.kms-add-to-cart, .qd-add-to-cart');

    // Viko sablonunda tema sepete ekle blogu kapali. Modul butonunu
    // dogrudan WhatsApp baglantisinin ustune al.
    if (!buttons || !submit) {
      const whatsapp = root.querySelector('.btn-whatsapp-custom');
      if (!whatsapp || !moduleButton || !visible(moduleButton)) return;
      arranging = true;
      try {
        const parked =
          moduleButton.nextElementSibling &&
          moduleButton.nextElementSibling.classList.contains('purchase-activate-note') &&
          moduleButton.nextElementSibling.nextElementSibling === whatsapp;
        if (!parked && moduleButton.nextElementSibling !== whatsapp) {
          whatsapp.insertAdjacentElement('beforebegin', moduleButton);
        }
        placeNote(moduleButton, moduleButton);
      } finally {
        arranging = false;
      }
      return;
    }

    arranging = true;
    try {
      let anchor = submit;
      if (moduleButton && visible(moduleButton)) {
        if (moduleButton.parentElement !== buttons) {
          submit.insertAdjacentElement('afterend', moduleButton);
        }
        anchor = moduleButton;
      }

      const waiting =
        moduleButton &&
        visible(moduleButton) &&
        moduleButton.disabled &&
        !/ekleniyor/i.test(moduleButton.textContent);
      let note = buttons.querySelector('.purchase-activate-note');
      if (waiting) {
        if (!note) {
          note = document.createElement('p');
          note.className = 'purchase-activate-note';
          note.textContent = 'Seçimler yapıldıktan sonra aktif olacaktır';
        }
        if (note.hidden) note.hidden = false;
        if (note.previousElementSibling !== anchor) anchor.insertAdjacentElement('afterend', note);
        anchor = note;
      } else if (note && !note.hidden) {
        note.hidden = true;
      }

      const whatsapp = root.querySelector('.btn-whatsapp-custom');
      if (whatsapp && whatsapp.parentElement !== buttons) {
        anchor.insertAdjacentElement('afterend', whatsapp);
      }
      if (whatsapp && whatsapp.parentElement === buttons && whatsapp.previousElementSibling !== anchor) {
        anchor.insertAdjacentElement('afterend', whatsapp);
      }

      const afterWhatsapp = whatsapp && whatsapp.parentElement === buttons ? whatsapp : anchor;
      // EasySell urun butonu .es-popup-button-product. .es-checkout-btn bazi
      // form alanlarinda kullaniliyor; ikisini de ayni siraya al.
      const cod = root.querySelector(
        '.es-popup-button-product, .es-checkout-btn, #es-popup-button'
      );
      if (cod && !cod.classList.contains('es-sticky') && cod.parentElement !== buttons) {
        afterWhatsapp.insertAdjacentElement('afterend', cod);
      } else if (
        cod &&
        !cod.classList.contains('es-sticky') &&
        cod.previousElementSibling !== afterWhatsapp
      ) {
        afterWhatsapp.insertAdjacentElement('afterend', cod);
      }

      const appBlock = root.querySelector('.shopify-app-block:has(easysell-form)');
      if (appBlock && cod && !appBlock.contains(cod) && !appBlock.hidden) {
        appBlock.hidden = true;
      }
    } finally {
      arranging = false;
    }
  }

  const observer = new MutationObserver(arrange);
  observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'disabled', 'class', 'style'] });
  arrange();
  window.addEventListener('load', arrange);
})();
